import type { Permission, SessionUser } from '@almacen/shared';
import { createContext, useContext } from 'react';

export interface AuthContextValue {
  user: SessionUser | null;
  /** true mientras se comprueba si hay sesión al cargar la aplicación. */
  checking: boolean;
  login: (username: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  can: (permission: Permission) => boolean;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth debe usarse dentro de <AuthProvider>');
  return context;
}
